module.exports = __webpack_public_path__ + "static/img/undefinedE.58edc52.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/undefinedE.png
// module id = n45w
// module chunks = 1